import 'is-in-viewport'

$(function () {
  animateInViewport()

  $('.text-list').each(function () {
    const $list = $(this)
    const $items = $list.find('.item')
    let current = 0

    function cycleOpacity() {
      $items.removeClass('!opacity-100')
      $items.eq(current).addClass('!opacity-100')
      current = (current + 1) % $items.length
    }

    // Start the cycle after 1s
    setTimeout(function startCycle() {
      cycleOpacity()
      setInterval(cycleOpacity, 1500)
    }, 500)
  })
})

$(window).scroll(function () {
  setTimeout(function () {
    animateInViewport()
  }, 100)
})

export function animateInViewport() {
  $(
    '.move-up-in-viewport, .move-down-in-viewport, .move-left-in-viewport, .move-right-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport, .full-width-in-viewport',
  )
    .filter(':not(.wait-to-animate)')
    .each(function () {
      var $this = $(this)

      if ($this.is(':in-viewport')) {
        $this.addClass('active')
      }
    })
}
